import { render } from "./UI.vue?vue&type=template&id=6fb8b3ed"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"

import "./UI.vue?vue&type=style&index=0&id=6fb8b3ed&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__